export const RETURN_URL_KEY = 'returnURL' as const;
